import { render, staticRenderFns } from "./MenuListTableOne.vue?vue&type=template&id=c5db4708&scoped=true"
import script from "./MenuListTableOne.vue?vue&type=script&lang=js"
export * from "./MenuListTableOne.vue?vue&type=script&lang=js"
import style0 from "./MenuListTableOne.vue?vue&type=style&index=0&id=c5db4708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5db4708",
  null
  
)

export default component.exports